// extracted by mini-css-extract-plugin
export default {"row":"table-row_row__D8xBu","status":"table-row_status__lyJ24"};